import { primary, white } from 'hfty-styles/src/colors'
import { flex } from 'hfty-styles/src/mixins'

const CONTAINER_WIDTH = '620px'

export const styles = {
  footer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    width: '100%',
    marginTop: '25px',
    paddingTop: '25px',
    borderTop: `1px solid rgb(197, 197, 197)`,
  },
  container: {
    ...flex('space-between'),
    width: CONTAINER_WIDTH,
  },

  totalPriceTable: {
    width: '200px',
  },
  orderTotalTitle: {
    color: 'rgb(121, 121, 121)',
    fontSize: 18,
  },
  orderTotalValue: {
    color: primary(),
    fontSize: 18,
  },

  submitButton: {
    width: '160px',
    height: '45px',
    fontSize: '17px',
    color: white(),
    backgroundColor: primary(),
    border: `1px solid ${primary()}`,
    cursor: 'pointer',
    outline: 'none',
  },
}
